// extracted by mini-css-extract-plugin
export default {"container":"eW-z","title":"fW-z","link":"gW-z"};